module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"button":"Печатать схему проезда"}}')
  delete Component.options._Ctor
}
